export const instHub = () => ({
  title: "Hub E21 | Multiversa",
  link: [
    {
      rel:"preload",
      as:"image",
      href: "https://ik.imagekit.io/cyrcl27sn/banners/hub-seo.jpg"
    },
    {
      rel:"canonical",
      href: "https://multiversa.com/hub-e21/"
    },
  ],
  meta: [
    {
      hid: "https://multiversa.com/hub-e21/",
      name: "Hub E21 | Multiversa",
      content: "O E21 é o hub de inovação da Faculdade Multiversa, com foco na propulsão de negócios, na realização de atividades direcionadas ao público da região, fomrando uma rede integrada e coerente com o ecossistema empreendedor.",
      keywords: "educacao, multiversa, inovação, empreendedorismo, hub, coworking, negócios, incubadora"
    },
    {
      name: "thumbnail",
      content: "https://ik.imagekit.io/cyrcl27sn/banners/hub-seo.jpg"
    },
    { name:"type", content: "website"},
    {property: "fb:app_id", hid: "fb:app_id", name:"fb:app_id", content: "390367489652187", },
    {property: "og:title", hid: "og:title", name:"og:title", content: "Hub E21 | Multiversa" },
    {property: "og:description", hid: "og:description", name:"og:description", content: "O E21 é o hub de inovação da Faculdade Multiversa, com foco na propulsão de negócios, na realização de atividades direcionadas ao público da região, fomrando uma rede integrada e coerente com o ecossistema empreendedor." },
    {property: "og:site_name", hid: "og:site_name", name:"og:site_name", content: "Hub E21 | Multiversa"},
    {property: "og:type", hid: "og:type", name:"type", content: "website"},
    {property:"og:image:secure_url", hid: "og:image:secure_url", itemprop:"image", name: "og:image:secure_url", content: "https://ik.imagekit.io/cyrcl27sn/banners/hub-seo.jpg" },
    {property: "og:image", hid: "og:image", itemprop:"image", name: "og:image", content: "https://ik.imagekit.io/cyrcl27sn/banners/hub-seo.jpg" },
    {property: "og:image:type", hid: "og:image:type", name: "og:image:type", content: "image/jpg" },
    {property: "og:url", hid: "og:url", name: "og:url", content: "https://multiversa.com/" },
    
    {property: "twitter:card", hid: "twitter:card", name:"twitter:card",  content:"summary_large_image" },
    {property: "twitter:title", hid: "twitter:title", name:"twitter:title", content: "Hub E21 | Multiversa" },
    {property: "twitter:description", hid: "twitter:description", name:"twitter:description", content: "O E21 é o hub de inovação da Faculdade Multiversa, com foco na propulsão de negócios, na realização de atividades direcionadas ao público da região, fomrando uma rede integrada e coerente com o ecossistema empreendedor." },
    
    
    {name: "robots", content: "index,follow"}
  ]
})

